// extracted by mini-css-extract-plugin
export var optionGrid = "_2y-7";
export var optionList = "_2y-6";
export var questionsBlock = "_2y-9";
export var spacer = "_2y-5";
export var stepCenteredContent = "_2y-3";
export var stepInner = "_2y-0";
export var stepInnerFullWidth = "_2y-1";
export var stepInnerLockScroll = "_2y-2";
export var stepTransitionFrame = "_2y-4";
export var welcomeBlock = "_2y-8";